export default __webpack_public_path__ + "static/media/img11.f0d1a6f3.PNG";